import { render, staticRenderFns } from "./CartViewB2C.vue?vue&type=template&id=09088012&scoped=true&"
import script from "./CartViewB2C.vue?vue&type=script&lang=ts&"
export * from "./CartViewB2C.vue?vue&type=script&lang=ts&"
import style0 from "./CartViewB2C.vue?vue&type=style&index=0&id=09088012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09088012",
  null
  
)

export default component.exports